import { OpenInNew } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useCallback } from "react";

type Props = { url: string };

const OpenURLChip = ({ url }: Props) => {
  const openURL = useCallback(() => {
    window.open(url, "_target");
  }, [url]);
  return (
    <Chip
      label={url}
      onClick={openURL}
      icon={<OpenInNew color="inherit" fontSize="small" />}
      sx={{
        backgroundColor: "#f0f0f0",
        fontSize: 14,
        border: "none",
        color: "#000",
      }}
    />
  );
};

export default OpenURLChip;
